<!-- <div class="w-full min-h-[200px] max-h-[56vh] relative overflow-auto" *ngIf="tableData.length > 0"> -->
<table class="intervention-table w-full select-none text-base min-w-full" mat-table [dataSource]="tableData">
  <!-- Define columns dynamically -->
  <ng-container *ngFor="let col of tableColumns | slice : frozenColStartIndex : frozenColEndIndex" [matColumnDef]="col.field" [sticky]="true">
    <th mat-header-cell *matHeaderCellDef [style.minWidth.px]="col.column_width" class="p-0 !font-bold text-base text-black">{{ col.label }}</th>
    <ng-container *matCellDef="let rowData; let i = index">
      <td mat-cell class="p-0 h-8" [style.minWidth.px]="col.column_width">
        <div
          class="h-full !border-l !border-r !border-l-[#c1bdbd] !border-r-[#c1bdbd]"
          [ngClass]="{
                '!border-t  !border-t-[#c1bdbd]': showTopBorder(rowData.intervention_id, rowData[col.field], i, col.field),
                '!border-b  !border-b-[#c1bdbd]': showBottomBorder(rowData.intervention_id, rowData[col.field], i, col.field),
              }"
        >
          <div
            class="px-1 h-full text-base absolute block -bottom-[10px] gap-2 truncate ..."
            [style.maxWidth.px]="col.column_width"
            *ngIf="visibleGroup(rowData.intervention_id, rowData[col.field], i, col.field)"
            [title]="rowData[col.field]"
          >
            <ng-container *ngIf="col.field == 'action'; else no_id">
              <mat-checkbox *ngIf="col.editable" class="bottom-1.5" (change)="onInterventionSelection($event, rowData)" [checked]="rowData.is_active" title="Select Intervention">
              </mat-checkbox>
              <i class="fa fa-pencil cursor-pointer !text-mdlz-primary relative mr-3 bottom-1.5" title="Edit Intervention" (click)="openEditIntervention(rowData)"></i>
              <i class="fa fa-trash cursor-pointer !text-mdlz-primary relative bottom-1.5" title="Delete Intervention" (click)="OnDeleteIntervention(rowData)"></i>
            </ng-container>
            <ng-template #no_id>
              {{ col['field'] == 'scope' ? (rowData[col.field] | scopeFormatter) : rowData[col.field] }}
            </ng-template>
          </div>
        </div>
      </td>
    </ng-container>
  </ng-container>
  <ng-container *ngFor="let col of tableColumns | slice : frozenColEndIndex : frozenColEndIndex + 1" [matColumnDef]="col.field" [sticky]="col.column_type == 'FROZEN'">
    <th mat-header-cell *matHeaderCellDef [style.minWidth.px]="col.column_width" class="p-0 !font-bold text-base text-black">{{ col.label }}</th>
    <td mat-cell *matCellDef="let rowData; let i = index" class="p-0 h-8 truncate ..." [style.minWidth.px]="col.column_width">
      <div class="px-1 h-full text-base flex items-center !border !border-[#c1bdbd]" [title]="rowData[col.field]">
        <span
          [ngClass]="{
            'pl-4': col['field'] === 'properties' && ['Incremental Throughput (lbs/shift)', 'Total Line Shifts'].includes(rowData[col.field])
          }"
        >
          <span *ngIf="col['field'] == 'scope'"> {{ rowData[col.field] | scopeFormatter }}</span>
          <span *ngIf="col['field'] == 'properties'" [innerHTML]="rowData[col.field] | propertyFormatter"> </span>
        </span>
      </div>
    </td>
  </ng-container>

  <ng-container *ngFor="let col of tableColumns | slice : frozenColEndIndex + 1; let colIndex = index" [matColumnDef]="col.field" class="z-0">
    <th mat-header-cell *matHeaderCellDef [style.minWidth.px]="col.column_width" class="p-1 !text-center">
      <div class="inline font-bold text-base text-black text-center w-full">
        {{ col.label }}
      </div>
    </th>
    <td
      mat-cell
      *matCellDef="let rowData"
      class="h-8 p-0 truncate ..."
      [style.minWidth.px]="col.column_width"
      [class.selected-cell]="col.editable && isCellSelected(rowData.id, colIndex + frozenColEndIndex + 1)"
      (mousedown)="onMouseDown(rowData.id, colIndex + frozenColEndIndex + 1)"
      (mousemove)="onMouseMove($event, rowData.id, colIndex + frozenColEndIndex + 1)"
      (mouseup)="onMouseUp()"
      (dblclick)="$event.stopPropagation(); col.editable && onCellEditInit({ field: col.field, data: rowData })"
    >
      <div class="h-full" *ngIf="editMode[rowData.id][col.field]">
        <input
          #editInput
          pInputText
          type="number"
          pattern="^-?\d*(\.\d{0,3})?$"
          (focus)="$event.target['select']()"
          [(ngModel)]="rowData[col.field]"
          (keyup.esc)="onCellEditCancel({ field: col.field, data: rowData })"
          (keyup.enter)="onCellEditComplete({ field: col.field, data: rowData, rowIndex: rowData.id, columnIndex: colIndex + frozenColEndIndex + 1 })"
          (focusout)="onCellEditComplete({ field: col.field, data: rowData, rowIndex: rowData.id, columnIndex: colIndex + frozenColEndIndex + 1 })"
          class="h-full w-full py-0 px-1 hover:border-mdlz-primary text-sm rounded-none border border-mdlz-primary"
        />
      </div>
      <div
        class="px-1 h-full flex items-center text-base justify-center !border !border-[#c1bdbd]"
        *ngIf="!editMode[rowData.id][col.field] || !col.editable"
        [ngClass]="{ 'font-bold': rowData[col.field + '_dirty'] }"
        [title]="rowData[col.field]"
      >
        <div class="numeric-value" *ngIf="['Integer', 'Float', 'number'].includes(col.data_type)">
          {{ rowData[col.field] | number : '1.0-0' }}
        </div>
      </div>
    </td>
  </ng-container>

  <!-- Header and Row Definitions -->
  <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: visibleColumns"></tr>

  <!-- No Data Row -->
  <tr *matNoDataRow>
    <td colspan="2">No Data Found</td>
  </tr>
</table>
<!-- </div> -->

<!-- Delete Interventions Confirmation Box -->
<p-confirmDialog #cd header="Delete Intervention" class="delete-text" [style]="{ width: '40vw', height: '15rem' }">
  <ng-template pTemplate="footer">
    <button class="mdlz-btn" (click)="cd.accept()" mat-button>Agree</button>
    <button class="mdlz-btn-outline cancel !hover:text-white" (click)="cd.reject()" mat-button>Cancel</button>
  </ng-template>
</p-confirmDialog>
